import { Maybe, WishlistItemInterface, Wishlist } from '@pylot-data/pylotschema'
import { WishlistState } from '../Hooks/WishlistActionTypes'

export interface GetWishlistInterfaceArgs {
    wishlist: Wishlist
    item?: Maybe<WishlistItemInterface>
    wishlistState?: WishlistState
}

export interface GetWishlistOutputInterface {
    wishlist_item_id: string
    quantity: number | undefined
}

export const getWishlistItems = ({
    wishlist,
    item,
    wishlistState
}: GetWishlistInterfaceArgs): Array<GetWishlistOutputInterface> => {
    if (wishlistState) {
        const selectedItems: Array<GetWishlistOutputInterface> = []

        wishlist?.items_v2?.items?.forEach((item_v2) => {
            if (wishlistState?.selected?.includes(String(item_v2?.id))) {
                selectedItems.push({
                    wishlist_item_id: String(item_v2?.id),
                    quantity: item_v2?.quantity
                })
            }
        })

        return selectedItems
    }

    return [
        {
            wishlist_item_id: String(item?.id),
            quantity: item?.quantity
        }
    ]
}
